import React from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { updateEmployee } from './actions/update-employee';

import { EmployeeSupervisorsBase } from './employee-supervisors-base';

import { employeeName } from './utils/employee-name';
import { confirm } from '../widgets/confirmation-dialog';

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { employee: { employeeId } }: InputProps,
) => ({
  actions: {
    updateEmployee: (update: Partial<EmployeeUpdateRequest>) =>
      dispatch(updateEmployee(employeeId, update)),
  },
});

type InputProps = {
  employee: Employee;
};

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & DispatchProps;

export const EmployeeSupervisors = connect(
  undefined,
  mapDispatchToProps,
)(({ actions, employee }: Props) => {
  const handleRemove = (removeId: number) => {
    const newSupervisorIds = employee.Supervisors.map((s) => s.employeeId).filter(
      (id) => id !== removeId,
    );
    actions.updateEmployee({ Supervisors: newSupervisorIds });
  };

  const handleAdd = (addId: number) => {
    const newSupervisorIds = employee.Supervisors.map((s) => s.employeeId).concat([addId]);
    actions.updateEmployee({ Supervisors: newSupervisorIds });
  };

  const handleNoSupervisor = async (hasNoSupervisor: boolean) => {
    if (employee.Supervisors.length > 2) {
      return (
        (await confirm(
          `Are you sure you want to remove all supervisors from ${employeeName(employee)}?`,
        )) &&
        actions.updateEmployee({
          Supervisors: [],
          hasNoSupervisor,
        })
      );
    }
    return actions.updateEmployee({
      Supervisors: [],
      hasNoSupervisor,
    });
  };

  const supervisorIds = employee.Supervisors.map((s) => s.employeeId);

  return (
    <EmployeeSupervisorsBase
      employeeId={employee.employeeId}
      orgId={employee.orgId}
      supervisorIds={supervisorIds}
      hasNoSupervisor={employee.hasNoSupervisor}
      onRemove={handleRemove}
      onAdd={handleAdd}
      onNoSupervisor={handleNoSupervisor}
    />
  );
});
